import { memo, useMemo, useState } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { FormikProps } from 'formik';
import { MButton, MInput } from '@Components/Base';

import styles from './email-creation-notification.module.css';

import { initFormikValuesType } from './types';

interface EmailCreationNotificationProps {
  title: string;
  textSuccessBtn: string;
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  handleSuccess: () => void;
  handleCancel: () => void;
  textCancelBtn?: string;
}

const EmailCreationNotification: React.FC<EmailCreationNotificationProps> = ({
  title,
  isModalOpen,
  textSuccessBtn,
  textCancelBtn = 'No, Thanks',
  formik,
  handleSuccess,
  handleCancel,
}) => {
  const [isDisable, setIsDisable] = useState(true);

  const customButtons = useMemo(() => {
    return [
      <MButton key="back" type="tertiary" onClick={handleCancel}>
        {textCancelBtn}
      </MButton>,
      <MButton
        key="submit"
        type="primary"
        onClick={handleSuccess}
        disabled={isDisable}
      >
        {textSuccessBtn}
      </MButton>,
    ];
  }, [textCancelBtn, textSuccessBtn, handleSuccess, handleCancel, isDisable]);

  return (
    <Modal
      open={isModalOpen}
      onOk={handleSuccess}
      onCancel={handleCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        </Flex>
        <div className={styles.fieldsSection}>
          <div>
            <Typography.Text>Email ID / Username:</Typography.Text>
            <MInput
              name="userName"
              value={formik.values.username}
              onChange={(input) => {
                formik.setFieldValue('username', input.target.value);
              }}
              onBlur={(event) => {
                const isValidUsername = event.target.value.includes('@');
                const isValidPassword = formik.values.password.length > 4;
                setIsDisable(!(isValidUsername && isValidPassword));
              }}
              placeholder="Type Username or Email ID"
            />
          </div>

          <div>
            <Typography.Text>Password:</Typography.Text>
            <MInput
              name="password"
              onChange={(input) =>
                formik.setFieldValue('password', input.target.value)
              }
              onBlur={(event) => {
                const isValidPassword = event.target.value.length > 4;
                const isValidUsername = formik.values.username.includes('@');
                setIsDisable(!(isValidUsername && isValidPassword));
              }}
              placeholder="Type Password"
            />
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default memo(EmailCreationNotification);
